import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class CostCenterThaiProvider {

  private _service: string = 'payroll';
  private _model: string = 'costCenterThai';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public jvReport(year: any, periodCode: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'jvReport';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof year !== 'undefined' && year !== null) _urlParams.year = year;
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/costCenterThai/cost.center.thai.ts